// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"db5943c1","453":"20ceca13"}[chunkId] + ".chunk.js";
};